import { LOGOUT_REQUEST } from "../../Auth/slices/authActions";
import {
  ZALO_STATUS_CHANGED,
  ZALO_STATUS_RESET,
  ZALO_STATUS_SNAPSHOT_RECEIVED,
  ZALO_STATUS_SUBSCRIPTION_CONNECTED,
  ZALO_STATUS_SUBSCRIPTION_DISCONNECTED,
} from "./zaloStatusActions";

const initState = {
  byShopId: {},
  allShopIds: [],
  connected: false,
  lastSnapshotAt: null,
};

const normalizeShop = (shop) => ({
  ...shop,
  lastUpdateAt: Date.now(),
});

const zaloStatusReducer = (state = initState, action) => {
  switch (action.type) {
    case ZALO_STATUS_SNAPSHOT_RECEIVED: {
      const shops = Array.isArray(action.payload?.shops)
        ? action.payload.shops
        : [];
      const byShopId = {};
      const allShopIds = [];
      for (const shop of shops) {
        if (!shop || !shop.id) continue;
        byShopId[shop.id] = normalizeShop(shop);
        allShopIds.push(shop.id);
      }
      return {
        ...state,
        byShopId,
        allShopIds,
        lastSnapshotAt: Date.now(),
      };
    }
    case ZALO_STATUS_CHANGED: {
      const shop = action.payload?.shop;
      if (!shop || !shop.id) return state;

      // Remove soft-deleted shops so selectors don't need to filter them.
      if (shop.isDelete) {
        if (!state.byShopId[shop.id]) return state;
        const { [shop.id]: _removed, ...restById } = state.byShopId;
        return {
          ...state,
          byShopId: restById,
          allShopIds: state.allShopIds.filter((id) => id !== shop.id),
        };
      }

      const exists = Boolean(state.byShopId[shop.id]);
      return {
        ...state,
        byShopId: {
          ...state.byShopId,
          [shop.id]: normalizeShop({
            ...(state.byShopId[shop.id] || {}),
            ...shop,
          }),
        },
        allShopIds: exists ? state.allShopIds : [...state.allShopIds, shop.id],
      };
    }
    case ZALO_STATUS_SUBSCRIPTION_CONNECTED:
      return { ...state, connected: true };
    case ZALO_STATUS_SUBSCRIPTION_DISCONNECTED:
      return { ...state, connected: false };
    case ZALO_STATUS_RESET:
    case LOGOUT_REQUEST:
      return initState;
    default:
      return state;
  }
};

export default zaloStatusReducer;
